import { AutoCallIcon } from '../Common/Icons';

export const getModalDataForCall = (hubRecord, cancelCallModal, startCall, trans) => ({
  icon: <AutoCallIcon className="auto-call-icon" />,
  title: <div className="auto-call-title">{trans('AUTO_ANSWER')}</div>,
  description: <div className="auto-call-description">{trans('AUTO_ANSWER_DESCRIPTION')}</div>,
  subdescription: <div className="sub-call-description">{''}</div>,
  cancel: cancelCallModal,
  ring: () => {
    startCall({ callees: [hubRecord], hubRecord });
    cancelCallModal();
  },
  proceed: () => {
    startCall({
      callees: [hubRecord],
      hubRecord,
      autoAccept: true,
    });
    cancelCallModal();
  },
});
